import { log } from './log';

export function preloadInstance()
{
    log('info', 'lifecycle::preloadInstance');

    return true;
}
